import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../../app.state';
import { Http } from '@angular/http';
import { Config } from '../../universal-config';

export const CAPTURE_ROLES = [
  'screenshot',
  'screencast',
  'video',
  'streaming_video',
]

@Injectable()
export class NoteService {
  private editorInstance;
  authDomain;
  nimbusUrl;
  nimbusDomain;

  constructor(
    public _config: Config,
  ) {
    this.authDomain = this._config.get('AUTH_HOST');
    this.nimbusUrl = this._config.get('NIMBUS_URL');
    this.nimbusDomain = this._config.get('NIMBUS_DOMAIN');
  }

  setEditorInstance(editorInstance) {
    this.editorInstance = editorInstance;
  }

  scrollToHash(hash?) {
    const blot = hash ? hash : document.location.hash;
    if(!blot) return;
    let block = this.editorInstance.scroll.domNode.querySelector(blot);
    if(block) {
      this.editorInstance.plugins.scrollSaver.scrollToBlot(blot, true, true);
    }
  }

  startSearch(close?: boolean) {
    if(this.editorInstance
    && this.editorInstance.plugins
    && this.editorInstance.plugins.search) {
      if(close) {
        this.editorInstance.plugins.search.end();
      } else {
        this.editorInstance.plugins.search.start();
      }

    }
  }

  getNodeUrl(org, workspaceId, nodeId, nodeType) {
    const nimbusUrl = this.getNimbusUrl(org);
    if(nodeId && workspaceId && nodeType) {
      return `${nimbusUrl}/ws/${workspaceId}/${nodeType}/${nodeId}`;
    }
  }

  getNimbusUrl(org) {
    if(org) {
      if(org.domain) {
        return `http://${org.domain}`;
      } else {
        return `http://${org.sub}.${this.nimbusDomain}`;
      }
    } else {
      return this.nimbusUrl;
    }
  }
}
